// src/components/Layout/Sidebar.jsx
import { NavLink, useNavigate } from "react-router-dom";
import { MdOutlineDashboard, MdLocationPin, MdClose, MdOutlineMyLocation } from "react-icons/md";
import { FaCarTunnel } from "react-icons/fa6";
import { IoPersonAddSharp, IoExit } from "react-icons/io5";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { TfiAngleDoubleLeft, TfiAngleDoubleRight } from "react-icons/tfi";
import { useAuth } from "../../contexts/loginContext";
import { ROLES_BOLETAS, ROLES_OPERATIVOS } from "../../contexts/roles";
import "./sidebar.css";

export default function Sidebar({
  isMobileOpen,
  isCollapsed,
  onCloseMobile,
  onToggleCollapse,
}) {
  const { logout, role, designation, hrKey } = useAuth();
  const navigate = useNavigate();

  const isAdmin = role === "admin";
  const isRootAdmin = isAdmin && String(hrKey || "") === "0";
  const isManager = role === "manager";
  const isSecretaria = role === "secretaria";
  const canSeeOperativo = ROLES_OPERATIVOS.includes(role);
  const canSeeBoletas = ROLES_BOLETAS.includes(role);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error("Error en logout:", err);
    } finally {
      navigate("/login", { replace: true });
    }
  };

  const panelTitle = isAdmin
    ? "PANEL DEL ADMINISTRADOR"
    : isManager
      ? `PANEL: ${designation || "ENCARGADO DE AREA"}`
      : isSecretaria
        ? "PANEL: SECRETARÍA"
        : "PANEL: VISTA ";

  return (
    <aside
      className={`sidebar ${isMobileOpen ? "open" : ""} ${isCollapsed ? "collapsed" : ""}`}
    >
      <div className="sidebar__brand">
        <div className="sidebar__brand-icon">
          <img src="/logo192.png" alt="Logo del Portal del Trabajador" />
        </div>
        {!isCollapsed && (
          <div className="sidebar__brand-text">
            <div className="sidebar__brand-title">Portal del Trabajador</div>
            <div className="sidebar__brand-subtitle">Centro Guaman Poma de Ayala</div>
          </div>
        )}
      </div>

      <div className="sidebar__top">
        <div className="sidebar__role-wrap">
          {!isCollapsed && (
            <div className="sidebar__role">
              {panelTitle}
            </div>
          )}
        </div>

        <div className="sidebar__actions">
          <button
            type="button"
            className="sidebar__collapse desktop-only"
            onClick={onToggleCollapse}
            aria-label={isCollapsed ? "Abrir barra lateral" : "Cerrar barra lateral"}
            title={isCollapsed ? "Abrir barra lateral" : "Cerrar barra lateral"}
          >
            {isCollapsed ? <TfiAngleDoubleRight /> : <TfiAngleDoubleLeft />}
          </button>

          <button
            type="button"
            className="sidebar__close mobile-only"
            onClick={onCloseMobile}
            aria-label="Cerrar menú"
          >
            <MdClose />
          </button>
        </div>
      </div>

      <nav className="sidebar__nav">
        {canSeeOperativo && (
          <NavLink
            to="/dashboard"
            end
            className={({ isActive }) => (isActive ? "navbtn active" : "navbtn")}
            onClick={onCloseMobile}
          >
            <MdOutlineDashboard className="navbtn__icon" />
            {!isCollapsed && <span>Dashboard</span>}
          </NavLink>
        )}

        {canSeeOperativo && (
          <NavLink
            to="/asistencia-campo"
            className={({ isActive }) => (isActive ? "navbtn active" : "navbtn")}
            onClick={onCloseMobile}
          >
            <FaCarTunnel className="navbtn__icon" />
            {!isCollapsed && <span>Asistencia a campo</span>}
          </NavLink>
        )}

        {isAdmin && (
          <NavLink
            to="/asistencia-local"
            className={({ isActive }) => (isActive ? "navbtn active" : "navbtn")}
            onClick={onCloseMobile}
          >
            <MdLocationPin className="navbtn__icon" />
            {!isCollapsed && <span>Asistencia Local</span>}
          </NavLink>
        )}

        {isAdmin && (
          <NavLink
            to="/agregar-usuario"
            className={({ isActive }) => (isActive ? "navbtn active" : "navbtn")}
            onClick={onCloseMobile}
          >
            <IoPersonAddSharp className="navbtn__icon" />
            {!isCollapsed && <span>Agregar Usuario</span>}
          </NavLink>
        )}

        {isRootAdmin && (
          <NavLink
            to="/institution-notices"
            className={({ isActive }) => (isActive ? "navbtn active" : "navbtn")}
            onClick={onCloseMobile}
          >
            <HiOutlineSpeakerphone className="navbtn__icon" />
            {!isCollapsed && <span>Gestionar Notificaciones</span>}
          </NavLink>
        )}

        {isAdmin && (
          <NavLink
            to="/location-maintenance"
            className={({ isActive }) => (isActive ? "navbtn active" : "navbtn")}
            onClick={onCloseMobile}
          >
            <MdOutlineMyLocation className="navbtn__icon" />
            {!isCollapsed && <span>Mantenimiento Locales</span>}
          </NavLink>
        )}

        {canSeeBoletas && (
          <NavLink
            to="/boletas-firmadas"
            className={({ isActive }) => (isActive ? "navbtn active" : "navbtn")}
            onClick={onCloseMobile}
          >
            <HiOutlineDocumentCheck className="navbtn__icon" />
            {!isCollapsed && <span>Boletas firmadas</span>}
          </NavLink>
        )}

        <button type="button" className="navbtn logout" onClick={handleLogout}>
          <IoExit className="navbtn__icon" />
          {!isCollapsed && <span>Salir</span>}
        </button>
      </nav>
    </aside>
  );
}
